import { render, staticRenderFns } from "./purchase-edit.vue?vue&type=template&id=5d6b357d&scoped=true&"
import script from "./purchase-edit.vue?vue&type=script&lang=js&"
export * from "./purchase-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b357d",
  null
  
)

export default component.exports